/* eslint-disable array-callback-return */
import React, { useState, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { supabaseClient } from "../../component/supabaseClient";
import { useNavigate } from "react-router-dom";
import { MuiTheme } from "../../styles/MuiDataTableStyle";
import MUIDataTable from "mui-datatables";
import LoadingModal from "../../component/modals/LoadingModal";
import {MdEdit} from "react-icons/md";
import {
  textLabels,
  downloadOptions,
  sortFunction,
} from "../../utils/MuiTableOptions";

import { GoBackButton } from "../../component/GoBackButton";
import { errAndMsg } from "../../utils/MsgAlert";

function Marca() {
  const navigate = useNavigate();

  const [marca, setMarca] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getMarca = async () => {
      const { data, error } = await supabaseClient
        .from("marca")
        .select(`*, productos(count)`)
        .eq("mostrar", true)
        .order("marcaId", { ascending: true });
      if (error) {
        errAndMsg("Error al obtener marcas", error.message, error.code);
      }
      data && setMarca(data);
    };
    getMarca();
  }, []);

  const editMarca = (event) => {
    marca?.map((m) => {
      if (m.marcaId === parseInt(event.currentTarget.id)) {
        navigate("editar-marca", {
          state: {
            marca: m,
          },
        });
      }
    });
  };

  const columns = [
    {
      name: "marcaId",
      label: "Id",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (columnMeta) => (
          <th style={{ backgroundColor: "#f0f0f0", textAlign: "center" }}>
            {columnMeta.label}
          </th>
        ),
      },
    },
    {
      name: "descripcion",
      label: "Descripcion",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (columnMeta) => (
          <th style={{ backgroundColor: "#f0f0f0", textAlign: "center" }}>
            {columnMeta.label}
          </th>
        ),
      },
    },
    {
      name: "acciones",
      label: "Acciones",
      options: {
        customHeadRender: (columnMeta) => (
          <th style={{ backgroundColor: "#f0f0f0", textAlign: "center" }}>
            {columnMeta.label}
          </th>
        ),
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            <div className="crud__table__icon-container">
              <MdEdit
                id={marca[dataIndex].marcaId}
                style={{ cursor: "pointer" }}
                className="crud__table__icon"
                alt="Item menú"
                onClick={editMarca}
              />
            </div>
          );
        },
        filter: false,
        sort: false,
      },
    },
  ];

  const options = {
    searchOpen: true,
    textLabels,
    downloadOptions,
    filter: true,
    selectableRows: "none",
    fixedHeader: false,
    filterType: "dropdown",
    responsive: "standard",
    customSort: sortFunction,
    draggableColumns: { enabled: true },
  };

  return (
    <>
      <ThemeProvider theme={MuiTheme}>
        <div className="crud">
        <div className="crud__title">
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <GoBackButton />
              <div style={{ width: "100%" }}>
                <h3>Marcas</h3>
              </div>
            </div>
            <hr />
          </div>
          <MUIDataTable
            title={"Listado de marcas"}
            data={marca}
            columns={columns}
            options={options}
          />
          <div className="crud__rigth-buttons-container">
            <button
              className="btn btn-dark"
              onClick={() => {
                navigate("agregar-marca", { state: { marca: false } });
              }}
            >
              Agregar nueva marca
            </button>
          </div>
        </div>
        <LoadingModal
          text="Eliminando marca..."
          show={loading}
          setShow={setLoading}
        />
      </ThemeProvider>
    </>
  );
}

export default Marca;
